import React from 'react';
import { Modal, DialogContent } from "@material-ui/core";
import ReleasePlan from "./ReleasePlan";
import ReleasePlanModelLoader from "../common/loaders/ReleasePlanModelLoader";

/**
 * Release plan model.
 * @param props
 * @returns {*}
 * @constructor
 */


function ReleasePlanModel(props) {
    const { testSeries, lang, closeModal, open, dataStatus } = props;

    function renderList() {
        return (
            <Modal className="response-modal response-analysis-modal"
                   aria-labelledby="simple-modal-title"
                   aria-describedby="simple-modal-description"
                   open={open}
                   onClose={closeModal}>
                <DialogContent>
                    <div className="releasePlanPopupWraper">
                        <i className="fa fa-times releasePlanClose" onClick={closeModal}/>
                        <div className="ScrollWraper">
                            <ReleasePlan groups={testSeries.quizGroup} lang={lang}/>
                        </div>
                    </div>
                </DialogContent>
            </Modal>
        );
    }

    function renderLoader() {
        //we will show four cards to fill this space.
        return (
            <Modal className="response-modal response-analysis-modal"
                   aria-labelledby="simple-modal-title"
                   aria-describedby="simple-modal-description"
                   open={open}
                   onClose={closeModal}>
                <DialogContent>
                    <div className="releasePlanPopupWraper">
                        <i className="fa fa-times releasePlanClose" onClick={closeModal}/>
                        <div className="ScrollWraper">
                            <ReleasePlanModelLoader/>
                        </div>
                    </div>
                </DialogContent>
            </Modal>
        );
    }

    return (
        <React.Fragment>
            {
                dataStatus === 'PENDING' ? renderLoader() : renderList()
            }
        </React.Fragment>
    );
}

export default ReleasePlanModel;
